import { mainClient } from '@/utils/api/mainClient';
import { useQuery } from '@tanstack/react-query';

export type OrganizationRole = {
  role_id: string;
  tenant_id: string | null;
  role_name: string;
  role_code: string;
  is_active: boolean;
};

export const useOrganizationRoles = (organisationId: string | undefined) => {
  return useQuery<OrganizationRole[], Error>({
    queryKey: ['organization-roles', organisationId],
    queryFn: async () => {
      const { data } = await mainClient.get<{ roles: OrganizationRole[] }>(
        `/api/invites/roles/${organisationId}`
      );
      return data.roles ?? [];
    },
    enabled: !!organisationId,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
};
